import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { classMap } from 'lit/directives/class-map.js';

import '@effectivastudio/lit-components/components/avatar/element.js';
import '@effectivastudio/lit-components/components/timeago/element.js';

import style from './style.lit.css';

/**
 * Notification item with picture, title and info content.
 *
 * @prop createdAt - Time of notification creation
 * @prop href - Link leading to entire notification content
 * @prop icon - Shows chosen icon when picture not present
 * @prop isRead - When true, indicates the notification was read
 * @prop isPermanent - If true, indicates permanent notification
 * @prop picture - When present, shows user, group or content image
 *
 * @slot title - Notification title
 * @slot default - Notification content
 */

export default class Notification extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    createdAt: { type: Date },
    href: { type: String },
    icon: { type: String },
    isRead: { type: Boolean },
    isPermanent: { type: Boolean },
    picture: { type: String },
  };

  constructor() {
    super();
    this.icon = 'image';
    this.isRead = false;
    this.isPermanent = false;
  }

  render() {
    const classes = {
      read: this.isRead,
      permanent: this.isPermanent,
    };

    return html`
      <a href=${this.href} class=${classMap(classes)}>
        <ef-avatar
          layout="sm"
          icon=${this.icon}
          .picture=${this.picture}></ef-avatar>

        <div class="info">
          <h3 class="title"><slot name="title"></slot></h3>
          <slot></slot>

          <ef-timeago class="date" .timestamp=${this.createdAt}></ef-timeago>
        </div>
      </a>
    `;
  }
}

customElements.get('bu-notification') ||
  customElements.define('bu-notification', Notification);
